export default __webpack_public_path__ + "static/media/Networks and Information Security.efff029c.pdf";